<template>
  <div>
    <!-- Invoice Rejection Log Summary Section Start -->
    <div></div>
    <b-button
      v-if="allModuleId > 0"
      class="mb-1 mt-1"
      @click="showRTBIModal(allModuleId)"
      size="xs"
      style="font-size: 0.675rem"
      >Invoice Rejection Log Summary</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="RTBI-modal"
      hide-footer
      :title="Page_title"
    >
     <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="12">
          <b-button
            class="pull-right mb-1"
            v-if="RTBIList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getJobRTBIDetails', 'Export As Excel')"
            size="xs"
            style="font-size: 0.675rem"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <b-table
            show-empty
            stacked="md"
            :items="RTBIList"
            :fields="RTBIfields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideRTBIModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>

  <!-- Invoice Rejection Log Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_JOBID: {
      type: String,
      default: "",
    },
    PMC_JOBNO: {
      type: String,
      default: "",
    },
    PMC_JOBDATE: {
      type: String,
      default: "",
    },
    PMC_JOBTYPE: {
      type: String,
      default: "",
    },
    PMC_Client: {
      type: String,
      default: "",
    },
    PMC_Sline: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.PMC_JOBID) {
      // this.getRTBI();
    }
  },
  mounted() {},

  data() {
    return {
      Page_title: this.PMC_title,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      RTBIfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "JobType",
          mainkey: "JobType",
          label: "Job Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "JobTypeStr",
          mainkey: "JobTypeStr",
          label: "All Job Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "JOB NO",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "UserName",
          mainkey: "UserName",
          label: "Rejected User Name",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "RejectedDate",
          mainkey: "RejectedDate",
          label: "Rejected Date",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "log_comment",
          mainkey: "log_comment",
          label: "Reason",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "feedback",
          mainkey: "feedback",
          label: "Feedback",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "log_message",
          mainkey: "log_message",
          label: "MSG",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      RTBIList: [],
      allModuleId: this.PMC_JOBID,
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getRejectedInvModule("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getRejectedInvModule("Excell");
    },
    getRejectedInvModule(type) {
      this.RTBIList = [];
      let payload = {};
      if (this.PMC_JOBID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getJobRTBIDetails",
          allModuleId: this.PMC_JOBID,
          type: type,
        };

        CommonService.getAllExpenseList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.RTBIListFLAG == 1) {
               this.isLoading = false;
              if (type == "Excell") {
                if (data.RTBIList.length > 0) {
                  this.RTBIList = data.RTBIList;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.RTBIList.length > 0) {
                  this.RTBIList = data.RTBIList;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on RTBIList Error: ", error);
          });
      }
    },

    showRTBIModal(allModuleId) {
      this.RTBIList = [];
      this.$refs["RTBI-modal"].show();
      this.getRejectedInvModule("Normal");
      // this.isLoading = false;
    },
    hideRTBIModal() {
      this.RTBIList = [];
      this.$refs["RTBI-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// moduleBasedRejectInvTallyBillSummary.vue?949a5f30